export function callCostLabel(phoneNumber: string): string {
  if (phoneNumber?.length) {
    const prefix = phoneNumber.substring(0, 4);

    if (
      prefix === '0800' ||
      (parseInt(prefix) >= 800 && parseInt(prefix) <= 805)
    ) {
      return 'GlobalApplicativeConstants.callCost.freeCall';
    } else if (
      (parseInt(prefix) >= 810 && parseInt(prefix) <= 890) ||
      phoneNumber?.length === 4
    ) {
      return 'GlobalApplicativeConstants.callCost.premiumRateCall';
    } else {
      return 'GlobalApplicativeConstants.callCost.localCostCall';
    }
  } else return '';
}
